import React, { useContext } from "react";
import "./singlestyles.scss";
import { PersonnelType } from "../../../../types/GlobalType";
import { personnelContext } from "../../../../context/AppContext";

const PersonnelInfo = () => {
  const personnelData: PersonnelType = useContext(personnelContext);

  return (
    <div
      className="tuteur_info"
      style={{
        overflowY: "auto",
      }}
    >
      <h4 className="title_section">Information Elève</h4>
      <table>
        <tr>
          <td>Nom:</td>
          <td>{personnelData.nom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Post-Nom:</td>
          <td>{personnelData.postnom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Prénom:</td>
          <td>{personnelData.prenom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Fonction:</td>
          <td>{personnelData.fonction_designation?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Genre:</td>
          <td>{personnelData.sexe?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Domaine d'étude:</td>
          <td>{personnelData.domaine_designation?.toUpperCase()}, </td>
        </tr>
        <tr>
          <td>Niveau d'étude:</td>
          <td>{personnelData.grade_designation?.toUpperCase()}, </td>
        </tr>
      </table>
      {/* <h4 className="title_section_2">Adresse résidentielle</h4> */}
      {/* <table>
        <tr>
          <td>Avenue:</td>
          <td>{personnelData.avenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{personnelData.quartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{personnelData.commune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{personnelData.ville?.toUpperCase()}</td>
        </tr>
      </table> */}
    </div>
  );
};

export default PersonnelInfo;
